import importPage from './importPage';

export default {
    init() {
        this.exportSteps();
        this.exportTagsRemove();
    },
    exportSteps() {
        $('.export-next').on('click', function () {
            let thisBtn = $(this);

            if (thisBtn.hasClass('first-step')) {
                if ($('.import-select').val() !== '') {
                    $('.export-archive-btn').hide();
                    $('.import-body--select-row').hide();
                    $('.import-body--export-list-row').fadeIn(300);
                    $('.import-body--title').html('Select what you want to export:');
                    thisBtn.removeClass('first-step');
                    setTimeout(function () {
                        thisBtn.addClass('tags-step');
                    }, 300);
                }
            }

            if (thisBtn.hasClass('tags-step')) {
                let tagItem = $('.import-body--upload-row--list .item');
                let tagsList = $('.import-body--upload-row--list');

                if (tagItem.length > 0 && !tagsList.hasClass('invalid')) {
                    importPage.uploadProgressStep();
                } else {
                    tagsList.addClass('invalid');
                }
            }
        });
    },
    exportTagsRemove() {
        $('.import-body--upload-row--list .item span').on('click', function () {
            $(this).parent().remove();

            if ($('.import-body--upload-row--list .item').length === 0) {
                $('.import-body--upload-row--list').addClass('invalid');
            }
        });
    }
}